import { EarningsItemBase } from '@api';

export const earningsDataForEmptyState = (
  earningsData: EarningsItemBase,
  entityName: string,
  ticker: string
) => {
  return {
    company_name: entityName,
    exchange: earningsData.exchange,
    ticker,
    reported: earningsData.reported,
    reporting_date: earningsData.reporting_date,
    fiscal_period: earningsData.fiscal_period,
    fiscal_year: earningsData.fiscal_year,
    currency: earningsData.currency,
    eps: earningsData.eps,
    revenue: earningsData.revenue,
    scenarios: {
      beat: null,
      miss: null,
      actual: null,
    },
  };
};
